export default {
  tenantRole: {
    PLATFORM_OPERATOR: "Platform Operator",
    PLANT_OPERATOR: "Plant Operator",
    RESCUE_SERVICE: "Rescue Service",
    SERVICE_COMPANY: "Service Company",
  },
  approvalStatus: {
    PENDING: "Pending",
    APPROVED: "Approved",
    DENIED: "Denied",
    PENDING_INVITATION: "Pending Invitation",
    WITHOUT_EA_APPROVAL: "Without EA Approval",
  },
};
